<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <span
        class="board__icon"
        v-bind="attrs"
        v-on="on"
        v-html="handleGetIcon(type)"
      />
    </template>
    {{ $t(`type.${type}`) }}
  </v-tooltip>
</template>

<script>
import { icons } from '@/util/iconsSVG'

export default {
  name: 'BoardItemIcon',

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleGetIcon(type) {
      return icons[type]
    },
  },
}
</script>
